<template>
  <v-card class="flex-column d-flex flex">
    <v-card-text class="text--primary flex-column d-flex">
      <template v-if="calculationResponse.hasValidatieErrors || !calculationResponse.energieLabel">
        <v-row>
          <v-col class="font-weight-bold">
            {{ $t('aandeel-he.aandeel-hernieuwbare-energie') }}
          </v-col>
        </v-row>
        <v-divider class="mt-5 mb-5 pb-0 pt-2 col-6 error"></v-divider>
        <v-row>
          <v-col>
            <v-icon color="error">icon-alert</v-icon>
            {{ $t('errors.ahe-berekening') }}
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row class="d-flex flex">
          <v-col class="d-flex flex">
            <div class="flex-column flex text-align-center">
              <v-row>
                <v-col class="font-weight-bold" v-html="$t('aandeel-he.indicator-langetermijndoelstelling')"> </v-col>
              </v-row>
              <v-row>
                <div class="flex text mt-3">
                  <template v-if="calculationResponse.indicatorVoorLangetermijndoelstelling">
                    <v-progress-circular
                      :size="100"
                      :width="15"
                      :value="calculationResponse.indicatorVoorLangetermijndoelstelling.waarde.toFixed(0)"
                      :rotate="-90"
                      color="teal"
                      >{{
                        calculationResponse.indicatorVoorLangetermijndoelstelling.waarde.toFixed(0) +
                        calculationResponse.indicatorVoorLangetermijndoelstelling.meeteenheid
                      }}
                    </v-progress-circular>
                  </template>
                  <template v-else>
                    <strong>
                      {{ $t('aandeel-he.onbepaald') }}
                    </strong>
                  </template>
                </div>
              </v-row>
            </div>
          </v-col>
          <v-col>
            <div class="flex text-align-center">
              <v-row dense>
                <v-col>
                  <strong>
                    {{ $t('aandeel-he.label') }}
                  </strong>
                </v-col>
              </v-row>
              <v-row dense class="pt-3" justify="center">
                <v-col cols="6" lg="12">
                  <icon-block-arrow color="teal" :text="calculationResponse.energieLabel"></icon-block-arrow>
                </v-col>
              </v-row>
            </div>

            <div class="flex pt-3" style="-webkit-hyphens: auto; -moz-hyphens: auto; -ms-hyphens: auto; hyphens: auto">
              <v-row dense>
                <v-col cols="12" v-html="$t('aandeel-he.indicator-langetermijndoelstelling')"> </v-col>
                <v-col cols="10">
                  <hr />
                </v-col>
                <v-col></v-col>
              </v-row>
              <div>
                <v-row dense>
                  <v-col cols="7">
                    {{ $t('aandeel-he.elektriciteit') }}
                  </v-col>
                  <v-col cols="5" class="text-align-end">
                    <template v-if="calculationResponse.indicatorVoorLangetermijndoelstellingElektriciteitsbehoefte">
                      {{
                        calculationResponse.indicatorVoorLangetermijndoelstellingElektriciteitsbehoefte.waarde.toFixed(
                          0
                        ) + calculationResponse.indicatorVoorLangetermijndoelstellingElektriciteitsbehoefte.meeteenheid
                      }}
                    </template>
                    <template v-else>
                      {{ $t('algemeen.waarde-onbekend') }}
                    </template>
                  </v-col>
                  <v-col cols="7">
                    {{ $t('aandeel-he.warmte') }}
                  </v-col>
                  <v-col cols="5" class="text-align-end">
                    <template v-if="calculationResponse.indicatorVoorLangetermijndoelstellingWarmtebehoefte">
                      {{
                        calculationResponse.indicatorVoorLangetermijndoelstellingWarmtebehoefte.waarde.toFixed(0) +
                        calculationResponse.indicatorVoorLangetermijndoelstellingWarmtebehoefte.meeteenheid
                      }}
                    </template>
                    <template v-else>
                      {{ $t('algemeen.waarde-onbekend') }}
                    </template>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import EnumConstantsMixin from '@/mixins/EnumConstantsMixin';
import { mixins } from 'vue-class-component';
import ProgressCircleRow from '@/components/progress/ProgressCircleRow.vue';
import { AandeelHernieuwbareEnergieClass } from '@/domain/interface/aandeel-hernieuwbare-energie/AandeelHernieuwbareEnergieClass';
import IconBlockArrow from '@/components/icon/custom/IconBlockArrow.vue';
import { i18n } from '@/i18n';

@Component({
  methods: {
    i18n() {
      return i18n;
    },
  },
  components: { IconBlockArrow, ProgressCircleRow },
})
export default class HernieuwbareEnergieScore extends mixins(EnumConstantsMixin) {
  @Prop(Object) calculationResponse!: AandeelHernieuwbareEnergieClass;
}
</script>